/**
 * ghi-chu-crm.ts — Đọc ô ghi chú của CRM thành từng mục.
 *
 * CRM giữ toàn bộ ghi chú của một khách trong MỘT ô chữ, theo quy ước:
 *
 *   Lộc Hạnh ngày 20-01-2025
 *   anh Mạnh, khách sành trà, uống trà trung, trà ô long đủ cả
 *   Lộc Hạnh ngày 06-02-2025
 *   ...
 *
 * Bản sao của bộ tách phía backend (modules/orders/ghi-chu-crm.ts) để giao
 * diện hiện được ngay từ hồ sơ đã tải, không phải gọi thêm một lượt.
 */
const DONG_DAU = /^(.+?) ngày (\d{2}-\d{2}-\d{4})\s*$/

export interface MucGhiChu {
  nguoiGhi: string
  /** DD-MM-YYYY như CRM lưu; rỗng = mục cũ không theo quy ước. */
  ngay: string
  noiDung: string
}

export function tachGhiChu(ghiChu: string | null | undefined): MucGhiChu[] {
  const dong = (ghiChu ?? '').split(/\r?\n/)
  const ra: MucGhiChu[] = []
  let dangMo: MucGhiChu | null = null
  const dau: string[] = []
  for (const d of dong) {
    const m = DONG_DAU.exec(d)
    if (m) {
      if (dangMo) ra.push(dangMo)
      dangMo = { nguoiGhi: m[1].trim(), ngay: m[2], noiDung: '' }
      continue
    }
    if (dangMo) dangMo.noiDung += (dangMo.noiDung ? '\n' : '') + d
    else dau.push(d)
  }
  if (dangMo) ra.push(dangMo)
  const truoc = dau.join('\n').trim()
  if (truoc) ra.unshift({ nguoiGhi: '', ngay: '', noiDung: truoc })
  return ra.map((m) => ({ ...m, noiDung: m.noiDung.trim() })).filter((m) => m.noiDung || m.ngay)
}
